export default "__VITE_PUBLIC_ASSET__4ade2706__"